'use strict';

angular.module('app.segmentationReportSegment', [])
    .directive('segmentationReportSegmentDirective', function () {
        return {
            controller: 'segmentationReportSegmentCtrl',
            templateUrl: 'app/measure/segmentationReport/segmentationReportSegment/segmentationReportSegment.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })